<template>
  <v-dialog
      v-model="activeStat"
      max-width="1000px"
  >

    <v-card>
      <v-card-title>
        {{item ? $t("EditCategory") :$t("AddCategory") }}
      </v-card-title>

      <v-card-text>
        <EditCategoryForm :item="item" @edited="OnResult">

        </EditCategoryForm>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import EditCategoryForm from "@/components/Categories/EditCategoryForm";
export default {
  name: "EditCategoryDialog",
  components: {EditCategoryForm},
  props:{
    dialog:Boolean,
    item:Object,
    editedIndex : Number
    },data(){
      return {
        activeStat : this.dialog
      }
  }
  ,methods:{
    save(){
      this.$emit('edited' , {item : this.item , index : this.editedIndex})
    }
    ,close(){
      this.activeStat = false;
      this.editedIndex = -1;
      this.$emit('edited' , {item : null , index : this.editedIndex})
    },
    OnResult(res){
      console.log(res)
      this.$emit('edited' , {item : res , index : this.editedIndex})
    }
  },watch:{
    dialog (val) {
      this.activeStat = val;
    },
    activeStat(val){
      this.$emit('edited' , {item : null , index : this.editedIndex})
    }

  },
}
</script>

<style scoped>

</style>